<template>
  <div class="text-size-14">
    <div class="w-full d-flex items-center justify-content-between">
      <div class="order-label">
        <Tag
          v-if="isIndividualOffer && isShowAdditionalLabel"
          label="指名"
          class="text-primary-dark bg-primary-yellow label-text"
          data-testid="individual-label"
        />
        <Tag
          v-if="isLimited && isShowAdditionalLabel"
          label="限定"
          class="text-primary-dark bg-primary-yellow label-text"
          data-testid="limited-label"
        />
        <Tag :label="orderService" class="text-blue border-blue label-text" />
        <Tag
          :label="workCategoryLabel"
          class="text-blue border-blue label-text"
          data-testid="work-category-label"
        />
        <Tag
          v-if="isCareerOrder"
          label="説明会"
          class="text-blue border-blue label-text"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { getWorkerServiceById } from "@/const/workerService";
import { OrderDetail, SlimOrder } from "@/types/order/Order";
import { orderService } from "@/app/services/OrderService";
import Tag from "@/components/atoms/other/Tag.vue";

@Component({
  components: {
    Tag
  }
})
export default class OrderLabel extends Vue {
  @Prop({
    type: Object,
    required: true
  })
  order!: SlimOrder | OrderDetail;

  @Prop({
    type: String,
    default: null
  })
  orderService!: string | null;

  @Prop({
    type: Boolean,
    default: true
  })
  isShowAdditionalLabel!: boolean;

  get isLimited() {
    // this.orderServiceとは異なることに注意
    return orderService.isLimited(this.order as SlimOrder);
  }

  get isIndividualOffer() {
    return !!this.order.individualOfferWorker;
  }

  get workCategoryLabel() {
    return getWorkerServiceById(this.order.workerService).displayName;
  }

  get isCareerOrder() {
    return orderService.isCareerOrder(this.order);
  }
}
</script>

<style lang="scss" scoped>
.order-label {
  display: flex;
  gap: 4px;
}

.label-text {
  padding: 3px 5px;
  font-size: 12px;
  line-height: 16px;
}
</style>
